import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  padding: 24px 0px;
`;

export const FooterWrapper = styled.div`
  width: 296px;
  height: 120px;
`;
